import AdditionalInfo from "../steps/additional-info";
import AdvancedDegree from "../steps/advanced-degree";
import ApplicantType from "../steps/applicant-type";
import AttorneyQualities from "../steps/attorney-qualities";
import BeneficiaryRegion from "../steps/beneficiary-region";
import BookLss from "../steps/book-lss";
import CaseUrgency from "../steps/case-urgency";
import ChildAge from "../steps/child-age";
import ChildMaritalStatus from "../steps/child-marital-status";
import ChildProtectiveServices from "../steps/child-protective-services";
import ChildrenInfo from "../steps/children-info";
import ChildrenSafety from "../steps/children-safety";
import ContactInfo from "../steps/contact-info";
import ContactInfoCallNow from "../steps/contact-info-call-now";
import ContactInfoDlss from "../steps/contact-info-dlss";
import ContactInfoReschedule from "../steps/contact-info-reschedule";
import CreateMeeting from "../steps/create-meeting";
import CriminalHistory from "../steps/criminal-history";
import CurrentlyRepresented from "../steps/currently-represented";
import DeportationOrRemoval from "../steps/deportation-or-removal";
import DivorceAgreementStatus from "../steps/divorce-agreement-status";
import ExceptionalAbility from "../steps/exceptional-ability";
import FundingSource from "../steps/funding-source";
import GreenCardDuration from "../steps/green-card-duration";
import GreenCardStatus from "../steps/green-card-status";
import GreenCardType from "../steps/green-card-type";
import HasMinorChildren from "../steps/has-minor-children";
import HasUpcomingCourtEvent from "../steps/has-upcoming-court-event";
import HumanitarianStatus from "../steps/humanitarian-status";
import IntakeConfirmation from "../steps/intake-confirmation";
import IntakeConfirmationCallNow from "../steps/intake-confirmation-call-now";
import JobOffer from "../steps/job-offer";
import LocationConfirmation from "../steps/location-confirmation";
import LssCheckout from "../steps/lss-checkout";
import LssConfirmation from "../steps/lss-confirmation";
import LssIntro from "../steps/lss-intro";
import MainGoal from "../steps/main-goal";
import MarriedToCitizen from "../steps/married-to-citizen";
import MoreInfo from "../steps/more-info";
import OpposingParty from "../steps/opposing-party";
import OutOfScope from "../steps/out-of-scope";
import PartnerInteraction from "../steps/partner-interaction";
import PartnerInteractionUsStatus from "../steps/partner-interaction-us-status";
import PaymentDeclined from "../steps/payment-declined";
import PreferencesSummary from "../steps/preferences-summary";
import ServiceType from "../steps/service-type";
import SlotIsTaken from "../steps/slot-is-taken";
import SponsorInfo from "../steps/sponsor-info";
import SponsorStatus from "../steps/sponsor-status";
import SponsorType from "../steps/sponsor-type";
import StateSelection from "../steps/state-selection";
import type { StepProps } from "../steps/step.types";
import TouristVisaStatus from "../steps/tourist-visa-status";
import Unsupported from "../steps/unsupported";
import UnsupportedConfirmed from "../steps/unsupported-confirmed";
import UnsupportedCounty from "../steps/unsupported-county";
import UpcomingEventDate from "../steps/upcoming-event-date";
import UpdatePreference from "../steps/update-preference";
import VisaEligibility from "../steps/visa-eligibility";
import ZipCode from "../steps/zip-code";

import type { FunnelInputsNameMap } from "./config.types";

export const modelName = "funnel-step-v-2";

export const DELAY_MS = 2000;

// steps - pool of all possible steps

export const steps = {
  "service-type": ServiceType,
  "zip-code": ZipCode,
  "location-confirmation": LocationConfirmation,
  "more-info": MoreInfo,
  "case-urgency": CaseUrgency,
  unsupported: Unsupported,
  "unsupported-confirmed": UnsupportedConfirmed,
  "create-meeting": CreateMeeting,
  "contact-info": ContactInfo,
  "contact-info-reschedule": ContactInfoReschedule,
  "contact-info-call-now": ContactInfoCallNow,
  "contact-info-dlss": ContactInfoDlss,
  "state-selection": StateSelection,
  "green-card-status": GreenCardStatus,
  "green-card-type": GreenCardType,
  "partner-interaction": PartnerInteraction,
  "partner-interaction-us-status": PartnerInteractionUsStatus,
  "married-to-citizen": MarriedToCitizen,
  "green-card-duration": GreenCardDuration,
  "applicant-type": ApplicantType,
  "visa-eligibility": VisaEligibility,
  "tourist-visa-status": TouristVisaStatus,
  "sponsor-info": SponsorInfo,
  "sponsor-type": SponsorType,
  "sponsor-status": SponsorStatus,
  "child-age": ChildAge,
  "child-marital-status": ChildMaritalStatus,
  "job-offer": JobOffer,
  "advanced-degree": AdvancedDegree,
  "exceptional-ability": ExceptionalAbility,
  "humanitarian-status": HumanitarianStatus,
  "funding-source": FundingSource,
  "beneficiary-region": BeneficiaryRegion,
  "lss-checkout": LssCheckout,
  "has-minor-children": HasMinorChildren,
  "children-info": ChildrenInfo,
  "children-safety": ChildrenSafety,
  "child-protective-services": ChildProtectiveServices,
  "opposing-party": OpposingParty,
  "has-upcoming-court-event": HasUpcomingCourtEvent,
  "upcoming-event-date": UpcomingEventDate,
  "currently-represented": CurrentlyRepresented,
  "criminal-history": CriminalHistory,
  "deportation-or-removal": DeportationOrRemoval,
  "book-lss": BookLss,
  "slot-is-taken": SlotIsTaken,
  "payment-declined": PaymentDeclined,
  "out-of-scope": OutOfScope,
  "unsupported-county": UnsupportedCounty,
  "intake-confirmation": IntakeConfirmation,
  "intake-confirmation-call-now": IntakeConfirmationCallNow,
  "lss-confirmation": LssConfirmation,
  "lss-intro": LssIntro,
  "additional-info": AdditionalInfo,
  "main-goal": MainGoal,
  "divorce-agreement-status": DivorceAgreementStatus,
  "attorney-qualities": AttorneyQualities,
  "update-preference": UpdatePreference,
  "preferences-summary": PreferencesSummary,
} as const satisfies Record<string, (props: StepProps) => JSX.Element>;

/*
 * steps names - pool of all possible steps names
 * (similar to original steps object above but since some values and eventually all will be components)
 */
export const stepsNames = Object.keys(steps).reduce(
  (acc, key) => {
    return { ...acc, [key]: key };
  },
  {} as { [K in keyof typeof steps]: K },
);

/*
 * We need to know what are shared steps
 * to be able to query them without knowing the sub-practice they belong to
 */
export const sharedSteps: Array<string> = [
  stepsNames["zip-code"],
  stepsNames["case-urgency"],
  stepsNames["state-selection"],
  stepsNames["location-confirmation"],
  stepsNames["more-info"],
  stepsNames["create-meeting"],
  stepsNames["contact-info"],
  stepsNames["contact-info-call-now"],
  stepsNames["contact-info-dlss"],
  stepsNames["unsupported-confirmed"],
  stepsNames.unsupported,
  stepsNames["visa-eligibility"],
  stepsNames["applicant-type"],
  stepsNames["funding-source"],
  stepsNames["beneficiary-region"],
  stepsNames["lss-checkout"],
  stepsNames["has-minor-children"],
  stepsNames["children-info"],
  stepsNames["children-safety"],
  stepsNames["child-protective-services"],
  stepsNames["opposing-party"],
  stepsNames["has-upcoming-court-event"],
  stepsNames["upcoming-event-date"],
  stepsNames["currently-represented"],
  stepsNames["criminal-history"],
  stepsNames["deportation-or-removal"],
  stepsNames["book-lss"],
  stepsNames["slot-is-taken"],
  stepsNames["payment-declined"],
  stepsNames["out-of-scope"],
  stepsNames["unsupported-county"],
  stepsNames["intake-confirmation"],
  stepsNames["intake-confirmation-call-now"],
  stepsNames["lss-confirmation"],
  stepsNames["lss-intro"],
  stepsNames["contact-info-dlss"],
  stepsNames["additional-info"],
  stepsNames["sponsor-info"],
  stepsNames["main-goal"],
  stepsNames["divorce-agreement-status"],
  stepsNames["attorney-qualities"],
  stepsNames["update-preference"],
  stepsNames["preferences-summary"],
];

// List of steps that should trigger the intake webCalendarSuccess event
export const intakeCalendarSuccessSteps = [
  "contact-info",
  "contact-info-reschedule",
  "contact-info-call-now",
];

// practices - pool of all possible practices and their sub-practices

export const practices = {
  family: [
    "child-support",
    "child-custody",
    "divorce",
    "alimony",
    "else",
    "reschedule",
  ] as const,
  immigration: [
    "green-card",
    "citizenship",
    "fiance-visa",
    "other-visa",
    "else",
    "reschedule",
  ] as const,
} satisfies Record<string, Array<string>>;

export const funnelInputsNameMap: FunnelInputsNameMap = {
  // v2/funnel
  practice: "practice",

  // v2/funnel/[practice]
  subPractice: "subPractice",

  // v2/funnel/[practice]/[subPractice]
  campaignId: "campaignId",

  // Is part of pre-client A/B test
  preClientTreatment: "preClientTreatment",

  // service-type
  serviceType: "serviceType",

  // sponsor-info
  sponsorFirstName: "sponsorFirstName",
  sponsorLastName: "sponsorLastName",
  sponsorPhone: "sponsorPhone",

  // sponsor-type
  sponsorType: "sponsorType",

  // sponsor-status
  sponsorStatus: "sponsorStatus",

  // child-age

  isChildUnderTwentyOne: "isChildUnderTwentyOne",

  // child-marital-status

  isChildMarried: "isChildMarried",

  // job-offer

  jobOffer: "jobOffer",

  // advanced-degree

  advancedDegree: "advancedDegree",

  //exceptional-ability

  exceptionalAbility: "exceptionalAbility",

  // humanitarian-status

  humanitarianStatus: "humanitarianStatus",

  // green-card-status
  greenCardStatus: "greenCardStatus",

  // green-card-type
  greenCardType: "greenCardType",

  // fiance-relationship-status
  fianceRelationshipStatus: "fianceRelationshipStatus",

  // partner-interaction
  partnerInteraction: "partnerInteraction",

  // partner-interaction-us-status
  partnerInteractionUsStatus: "partnerInteractionUsStatus",

  // applicant-type
  applicantType: "applicantType",

  // married-to-citizen
  marriedToCitizen: "marriedToCitizen",

  // green-card-duration
  greenCardDuration: "greenCardDuration",

  // visa-eligibility
  visaEligibility: "visaEligibility",

  // tourist-visa-status
  touristVisaStatus: "touristVisaStatus",

  // zip-code
  county: "county",
  zipCode: "zipCode",
  stateCode: "stateCode",
  stateDisplayText: "stateDisplayText",

  // zip-code & state-selection
  state: "state",

  // post contact-info
  isQualifiedForLss: "isQualifiedForLss", // calculateLssQualification
  funnelActionId: "funnelActionId", // createLead
  leadId: "leadId",
  accountId: "accountId",
  oldLeadId: "oldLeadId",

  // case-urgency
  caseUrgency: "caseUrgency",

  // funding-source
  fundingSource: "fundingSource",

  // beneficiary-region
  beneficiaryRegion: "beneficiaryRegion",

  // more-info
  moreInfo: "moreInfo",

  // post more-info
  leadScore: "leadScore", // calculateLeadScore
  leadIntent: "leadIntent", // calculateLeadScore
  sessionStartTime: "sessionStartTime", // calculateLeadScore
  visitsCount: "visitsCount", // calculateLeadScore

  // CMN eligibility
  isEligibleForCmn: "isEligibleForCmn",

  // create-meeting
  eventStartTime: "eventStartTime",
  timezone: "timezone",

  // book-lss
  lssStartTime: "lssStartTime",

  // create-meeting & book-lss
  meetingType: "meetingType",

  // contact-info & contact-info-reschedule && contact-info-dlss
  firstName: "firstName",
  lastName: "lastName",
  phone: "phone",
  email: "email",
  approvedTerms: "approvedTerms",

  // has-minor-children
  hasMinorChildren: "hasMinorChildren",

  // children-info
  childrenInfo: "childrenInfo",

  // children-safety
  childrenSafety: "childrenSafety",

  // child-protective-services
  childProtectiveServices: "childProtectiveServices",

  // opposing-party
  opposingPartyFirstName: "opposingPartyFirstName",
  opposingPartyLastName: "opposingPartyLastName",
  opposingPartyPhone: "opposingPartyPhone",

  // has-upcoming-court-event
  hasUpcomingCourtEvent: "hasUpcomingCourtEvent",

  // upcoming-event-date
  upcomingEventDate: "upcomingEventDate",

  // currently-represented
  currentlyRepresented: "currentlyRepresented",

  // criminal-history
  criminalHistory: "criminalHistory",

  // deportation-or-removal
  deportationOrRemoval: "deportationOrRemoval",

  // post currently-represented
  visitorStatusCode: "visitorStatusCode", // updateVisitorStatusCode

  // lss-checkout
  checkoutStatus: "checkoutStatus",

  // LSS Checkout, pc_reschedule_lss_with_provider, pc_cancel_lss_with_provider
  bookitRequestId: "bookitRequestId",

  // main-goal
  mainGoal: "mainGoal",

  // divorce-agreement-status
  divorceAgreementStatus: "divorceAgreementStatus",

  // attorney-qualities
  attorneyQualities: "attorneyQualities",

  // update-preference
  updatePreference: "updatePreference",

  // is-attorney-available
  isAttorneyAvailable: "isAttorneyAvailable",

  // Roni's AI model value
  biddingModel: "biddingModel",

  // leadSource
  leadSource: "leadSource",

  // legal-plan-conversation-id
  legalPlanConversationId: "legalPlanConversationId",
} as const;
